import { all, call, put, takeEvery } from "redux-saga/effects";
import insightsApis from "src/api/insights";
import { common } from "src/types/index";
import { constants } from "src/constants/common";
import * as actions from "../slices/insightsSlice";

function validateResponse(response: common.ResponseGenerator) {
  if (response?.code === "-1") throw new Error("Session Expired");
  if (response?.code === "0" || response?.code === "2") throw response?.message;
}

// get insights data saga
const GetInsightsDataSaga = function* GetInsightsDataSaga({
  payload: { resolve, reject, queryParams },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      insightsApis.getInsightData,
      queryParams
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getInsightsDataSuccess(response?.data));
    resolve(response);
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error occurred";
    yield put(actions.getInsightsDataFailure(errorMessage));
    reject(error);
  }
};

// get logs data saga
const GetLogDataSaga = function* GetLogDataSaga({
  payload: { resolve, reject, queryParams },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      insightsApis.getLogData,
      queryParams
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }

    yield put(actions.getLogDataSuccess(response.data));
    resolve(response);
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error occurred";
    yield put(actions.getLogDataFailure(errorMessage));
    reject(error);
  }
};

// get history data saga
const GetHistorySaga = function* GetHistorySaga({
  payload: { resolve, reject, queryParams },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      insightsApis.getHistory,
      queryParams
    );

    validateResponse(response);

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }

    yield put(actions.getHistorySuccess(response.data));
    resolve(response);
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error occurred";
    yield put(actions.getHistoryFailure(errorMessage));
    reject(error);
  }
};

export default function* insightsSaga() {
  yield all([
    takeEvery(actions.getInsightsDataRequest, GetInsightsDataSaga),
    takeEvery(actions.getLogDataRequest, GetLogDataSaga),
    takeEvery(actions.getHistoryRequest, GetHistorySaga),
  ]);
}
